<template>
    <div class="modal__head">
        <slot name="additional"/>
        <slot>
            <div class="modal__head--inner">
                <div class="merchant__name">{{ rootData.name }}</div>
                <div class="merchant__address">{{ rootData.address?.full }}</div>
            </div>
        </slot>
    </div>
</template>
<script setup>
import { inject } from 'vue';
const rootData = inject('rootData');
</script>
<style lang="scss">
.merchant {
    &__name {
        font-weight: 700;
    }

    &__address {
        margin-top: 0.125rem;
        opacity: 0.85;
        font-size: 0.8125rem;
    }
}
.modal {
    &__head {
        align-items: center;
        border-radius: 8px 8px 0 0;
        padding: 16px;
        display: flex;
        justify-content: flex-start;
        position: sticky;
        top: 0;
        padding: 16px 24px 16px 16px;
        z-index: 1;
        background: #ffffff;
        border-bottom: 1px solid #e5e5e5;

        svg {
            margin-right: 0.625rem;
        }

        a {
            color: var(--text-primary);
        }
    }
}
</style>